import React from 'react';
import { useFeatureFlag } from '../../hooks/useFeatureFlag'; 

const TestFeatureFlagComponent = () => {
  const isFeatureActive = useFeatureFlag('newFeature');

  return (
    <div>
      {isFeatureActive ? <p>New Feature is Active</p> : <p>New Feature is Not Active</p>}
    </div>
  );
};

export default TestFeatureFlagComponent;